<template>
    <div class="cart__sticky">
        <div class="cart__total">
            <div class="cart__row v-centered">
                <div class="cart__grow">
                    <div class="cart__subtitle">Ваша корзина</div>
                </div>
                <div class="cart__right">
                    <router-link
                        to="/shop/cart/"
                        class="second_cansel_btn"
                        :data-element="$root.getDataElement('cart_cansel_btn')"
                        @click.native="resetCookieAndSendEvent"
                    >
                        Изменить заказ
                    </router-link>
                </div>
            </div>

            <div
                v-if="cart.hasOwnProperty('PAY_LATER') && cart.PAY_LATER && (!cart.hasOwnProperty('BALANCE') || cart.BALANCE <= 0)"
                class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div>Способ оплаты</div>
                </div>
                <div class="cart__right">
                    <div class="cart__later">Позже</div>
                </div>
            </div>
            <div
                v-if="cart.hasOwnProperty('PAY_LATER') && cart.PAY_LATER && (!cart.hasOwnProperty('BALANCE') || cart.BALANCE <= 0)"
                class="cart__prompt">
                <div class="cart__txt">
                    Выбранный способ оплаты не дает доступа ко всем возможностям Виртуальной АТС MANGO OFFICE.
                    Рекомендуем оплатить сейчас, чтобы использовать все 100% возможностей.
                </div>
                <router-link
                    to="/shop/cart/payment/"
                    :data-element="$root.getDataElement('cart_total_pay_nows_btn')"
                    class="button button--outline button--sm">
                    Оплатить сейчас
                </router-link>
            </div>

            <div v-if="cart['TOTAL_PRICE_MONTHLY'] > 0"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div>Разовый платеж</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span
                            :data-element="$root.getDataElement('cart_total_price_once')"
                            class="cart__val"
                        >{{ formatPrice(cart['TOTAL_PRICE_ONCE']) }} </span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <div v-if="cart['TOTAL_PRICE_MONTHLY'] > 0"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div>Ежемесячный платеж</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span
                            :data-element="$root.getDataElement('cart_total_price_monthly')"
                            class="cart__val cart__val--big"
                        >{{ formatPrice(cart['TOTAL_PRICE_MONTHLY']) }}</span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <div v-if="cart['TOTAL_PRICE_FULL'] !== cart['TOTAL_PRICE']"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div>Скидка</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span
                            :data-element="$root.getDataElement('cart_total_price_discount')"
                            class="cart__val cart__val--red"
                        >- {{
                                formatPrice(cart['TOTAL_PRICE_FULL'] - cart['TOTAL_PRICE'])
                            }}</span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <div v-if="cart['TOTAL_PRICE'] > 0"
                 class="cart__row cart__row--sm">
                <div class="cart__grow">
                    <div class="cart__name">Общая стоимость</div>
                </div>
                <div class="cart__right">
                    <div class="cart__price">
                        <span
                            :data-element="$root.getDataElement('cart_total_price')"
                            class="cart__val cart__val--big">{{ formatPrice(cart['TOTAL_PRICE']) }}</span>
                        <span class="cart__units"> руб.</span>
                    </div>
                </div>
            </div>
            <small class="cart__small">Все цены указаны с учетом НДС.</small>
            <button
                :data-element="$root.getDataElement('cart_submit_next')"
                type="submit"
                class="button cart__buy"
                :class="{'btn-wait':loader.cart}"
                :disabled="loader.cart"
                @click="$emit('nextButtonHandler')"
            >{{ cart['SUBMIT_BUTTON_TEXT'] }}
            </button>
        </div>

        <div class="cart__order">
            <small class="cart__fast">Вы сможете оплатить ваш заказ онлайн или позднее в течение 5 дней.</small>
            <ul class="payment mb-0">
                <li class="visa"></li>
                <li class="mastercard"></li>
                <li class="mir"></li>
                <li class="transfer"></li>
            </ul>
        </div>
    </div>
</template>

<script>
import priceFormatter from '../../../../lib/priceFormatter'

export default {
    name: 'CartTotalComponent',
    props: {
        cart: {
            type: Object
        },
        loader: {
            type: Object
        },
        showQuickBuyLink: {
            type: Boolean
        },
        isOpen: {
            type: Boolean,
            default: true
        },
    },
    data: function () {
        return {};
    },
    methods: {
        formatPrice: function (price) {
            return priceFormatter.format(price)
        },
        resetCookieAndSendEvent: function () {
            this.resetCookie();
            this.sendMgoEvent('cancel_order');
        },
        resetCookie: function () {
            document.cookie = 'select_vats_list=; path=/;';
        },
        sendMgoEvent: function (eventCode) {
            if (typeof window.mgoTriggerEvent !== 'function') {
                return;
            }

            window.mgoTriggerEvent(eventCode);
        }
    }
}
</script>